const STORAGE_HOST_PATTERN =
  /http:\/\/(?:146\.190\.168\.187:9002|minio:9000|localhost:9000|host\.docker\.internal:9002)\//g;

export function normalizeStorageUrl(value: string | null | undefined): string {
  if (!value || !shouldUseStorageProxy()) {
    return value || '';
  }

  return value.replace(STORAGE_HOST_PATTERN, '/storage/');
}

function shouldUseStorageProxy(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const hostname = window.location.hostname;
  const isLocalhost = hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '::1';

  return window.location.protocol === 'https:' && !isLocalhost;
}
